import React from 'react'
export default {
    logo: <span className="title">WAYZ位置商业智能平台</span>,
    prodName: "bi",
    statistic: true,
  }
